import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';

import { Box, Stack, Title } from '@highlight-cp/core-ui';

import { SvgIcons } from '../svg-icons';
import {
  PERSONA_CHAT_ALLOWED_IMAGE_FORMAT_LABELS,
  PERSONA_CHAT_DROP_GUIDANCE_MULTIPLE,
  PERSONA_CHAT_DROP_GUIDANCE_SINGLE,
} from './constants';
import classes from './file-drop-overlay.module.css';

export interface FileDropOverlayProps {
  fullPage?: boolean;
  maxFiles?: number;
}

const FileDropOverlay = ({ fullPage = false, maxFiles = 1 }: FileDropOverlayProps) => {
  const { t } = useTranslation();

  const guidance =
    maxFiles === 1
      ? t(PERSONA_CHAT_DROP_GUIDANCE_SINGLE, { formats: PERSONA_CHAT_ALLOWED_IMAGE_FORMAT_LABELS })
      : t(PERSONA_CHAT_DROP_GUIDANCE_MULTIPLE, {
          count: maxFiles,
          formats: PERSONA_CHAT_ALLOWED_IMAGE_FORMAT_LABELS,
        });

  return (
    <Box
      className={clsx(classes.overlay, fullPage && classes.fullPage)}
      aria-hidden
      data-testid="file-drop-overlay"
    >
      <Stack gap="md" align="center" className={classes.content}>
        <SvgIcons.FileDropImage />
        <Stack gap="xs" align="center">
          <Title order={2} ta="center">
            {t('Drop image to attach')}
          </Title>
          <Box className={classes.guidance} component="p">
            {guidance}
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

FileDropOverlay.displayName = 'FileDropOverlay';

export default FileDropOverlay;
